module.exports = __webpack_public_path__ + "img/yclients.4abba7e4.png";